import React, { useEffect, useState } from "react";
import "./style.css";
import Carousel from "../../components/Carousel";
import { useParams } from "react-router-dom";
import outsourced from "../../constants/outsourced";

function ProjectById() {

  let { id } = useParams();
  const [project, setProject] =  useState({images: [], title: ''})

  useEffect(() => {
    const pfound = outsourced.projects.find(p => p.id === +id)
    if(pfound){
      setProject(pfound)
    }
  }, [id])
  return (
    <div style={{marginTop: '60px', display: 'flex', justifyContent: 'space-evenly', flexDirection: 'column-reverse'}}>
      <Carousel images={project.images}/>
      <h2 style={{fontSize: '40px', marginLeft: '30px'}}>{`${project.title}`}</h2>
    </div>
  );
}

export default ProjectById;
